import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TankService } from '@services/tank.service';
import { TranslateService } from '@ngx-translate/core';
import { AppDialogService } from '@services/app-dialog.service';
import { TankRtuDeviceService } from '@services/tank-rtu-device.service';
import { take } from 'rxjs';
import { deviceTypeCategory } from '@interfaces/deviceTypeCategory';

export interface BeforeOpenPayload {
  cancel: boolean;
  context: object;
  proceed: () => void;
}


@Component({
  selector: 'app-unassign-tank-button',
  templateUrl: './unassign-tank-button.component.html',
  styleUrls: ['./unassign-tank-button.component.css'],
})
export class UnassignTankButtonComponent {
  DeviceTypeCategory = deviceTypeCategory
  @Input() tankId: number | null = null;

  @Output() unassignComplete = new EventEmitter<number>();
  @Input() deviceCategory: deviceTypeCategory;
  
  showAsCollapsed: boolean = false;

  constructor(
    private tankService: TankService,
    private _ts: TranslateService,
    private tankRtuDeviceService: TankRtuDeviceService,
    private appDialogService: AppDialogService
) {
  }

  onClick() {
    const confirmTitle = this.deviceCategory === this.DeviceTypeCategory.skyTankSensor ? this._ts.instant("TankGrid.UnassignTank.ConfirmDisconnectTitle") : this._ts.instant("TankGrid.UnassignTank.ConfirmUnassignTitle");
    const confirmMessage = this.deviceCategory === this.DeviceTypeCategory.skyTankSensor  ? this._ts.instant("TankGrid.UnassignTank.ConfirmDisconnectMessage") : this._ts.instant("TankGrid.UnassignTank.ConfirmUnassignMessage");

    this.appDialogService.showConfirmationDialog(
      confirmTitle,
      confirmMessage,
      this._ts.instant("TankGrid.UnassignTank.Yes"),
      this._ts.instant("TankGrid.UnassignTank.No"),
      null
    )
      .subscribe(confirmation => {
        if (confirmation) {
          this.unassignTank();
        }
      });

  }

  unassignTank() {
    const pendingMessage = this.deviceCategory === this.DeviceTypeCategory.skyTankSensor
      ? this._ts.instant("TankGrid.UnassignTank.DisconnectPendingMessage")
      : this._ts.instant("TankGrid.UnassignTank.UnassignPendingMessage");
    const pendingRef = this.appDialogService.showPersistentMessage(pendingMessage);

    this.tankRtuDeviceService
      .unassignTank(this.tankId)
      .pipe(take(1))
      .subscribe((success: any) => {
        pendingRef.dismiss();
        if (success) {
          const saveMessage = this.deviceCategory === this.DeviceTypeCategory.skyTankSensor  ? this._ts.instant("TankGrid.UnassignTank.DisconnectCompleteMessage") : this._ts.instant("TankGrid.UnassignTank.UnassignCompleteMessage");
          this.appDialogService.showSuccessMessage(saveMessage);
          this.unassignComplete.emit(this.tankId);
        }
        else {
          const failedMessage = this.deviceCategory === this.DeviceTypeCategory.skyTankSensor  ? this._ts.instant("TankGrid.UnassignTank.DisconnectFailed") : this._ts.instant("TankGrid.UnassignTank.UnassignFailed");
          this.appDialogService.showErrorMessage(failedMessage);
        }
      }, () => {
        pendingRef.dismiss();
        const failedMessage = this.deviceCategory === this.DeviceTypeCategory.skyTankSensor  ? this._ts.instant("TankGrid.UnassignTank.DisconnectFailed") : this._ts.instant("TankGrid.UnassignTank.UnassignFailed");
        this.appDialogService.showErrorMessage(failedMessage);
      });

  }
}
